import { LitElement, html, css } from 'lit';
import { customElement, property } from 'lit/decorators.js';

@customElement('bnb-logo')
export class BnbLogo extends LitElement {
  static styles = css`
    :host {
      display: inline-block;
    }

    .logo {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      text-decoration: none;
      color: inherit;
    }

    .logo-image {
      max-width: 100%;
      height: auto;
      display: block;
    }

    .logo-text {
      font-weight: 300;
      font-size: 1.25rem;
      white-space: nowrap;
    }

    /* Size variants */
    :host([size="sm"]) .logo-image {
      height: 32px;
    }

    :host([size="md"]) .logo-image {
      height: 48px;
    }

    :host([size="lg"]) .logo-image {
      height: 64px;
    }

    :host([size="xl"]) .logo-image {
      height: 80px;
    }

    /* Variant styles */
    :host([variant="light"]) .logo-text {
      color: white;
    }

    :host([variant="dark"]) .logo-text {
      color: #111827;
    }

    :host([variant="color"]) .logo-text {
      color: inherit;
    }
  `;

  @property({ type: String })
  variant: 'color' | 'white' | 'black' = 'color';

  @property({ type: String })
  size: 'sm' | 'md' | 'lg' | 'xl' = 'md';

  @property({ type: Boolean })
  'show-text': boolean = false;

  @property({ type: String })
  href?: string;

  private get logoSrc(): string {
    const baseUrl = '/logo';

    switch (this.variant) {
      case 'white':
        return `${baseUrl}/svg/White logo - no background.svg`;
      case 'black':
        return `${baseUrl}/svg/Black logo - no background.svg`;
      case 'color':
      default:
        return `${baseUrl}/svg/Color logo - no background.svg`;
    }
  }

  private get logoContent() {
    const logo = html`
      <div class="logo">
        <img
          class="logo-image"
          src="${this.logoSrc}"
          alt="BrandNewBroadcast"
          loading="lazy"
        />
        ${this['show-text'] ? html`
          <span class="logo-text">BrandNewBroadcast</span>
        ` : ''}
      </div>
    `;

    return this.href ? html`
      <a class="logo" href="${this.href}" title="BrandNewBroadcast">
        ${logo}
      </a>
    ` : logo;
  }

  render() {
    return this.logoContent;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'bnb-logo': BnbLogo;
  }
}